export default function transformWPPPageReferencesToGatsby(content, fromDomain, toDomain) {
  fromDomain = fromDomain.replace(/\//g, '\\/');

  const re = new RegExp('href="'+fromDomain+'+(.*?)/"', "gim");

  return content.replace(re, 'href="'+toDomain+'$1/"')
}
